<template>
  <div class="form-box">
    <el-form ref="scopedForm" :model="scopedForm" :rules="rules" label-width="118px" v-if="ifForm==1">

      <el-form-item label="手机号： " prop="newPhone">
        <el-input v-model="scopedForm.newPhone" class="input-with-select">
          <el-select slot="prepend" v-model="scopedForm.phonePrefix">
            <el-option key="1" label="+86" value="1"></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="图形验证码：" prop="imgCode">
        <el-input v-model="scopedForm.imgCode" class="imgCode"></el-input>
        <img :src="imgCodeSrc" alt class="imgCodeBtn" @click="getImgCode()" />
      </el-form-item> -->
      <el-form-item label="验证码：" prop="numCode">
        <el-input v-model="scopedForm.numCode" :class="['numCode', {load: validCode._load}]"></el-input>
        <el-button class="numCodeBtn" :loading="validCode._load" @click="sendSMS" :disabled="validCode.disabled">
          {{validCode._html}}</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "editPhone",
  props: ["ifForm", "isCall", "params"],
  data () {
    return {
      rules: {
        // oldPhone: [{ required: true, validator: isPhone, trigger: "blur" }],
        newPhone: [{ required: true, validator: isPhone, trigger: "blur" }],
        imgCode: [
          { required: true, message: "*请输入图形验证码", trigger: "blur" }
        ],
        numCode: [
          { required: true, message: "*请输入短信验证码", trigger: "blur" }
        ]
      },
      scopedForm: {
        phonePrefix: "1",
        oldPhone: "",
        newPhone: "",
        imgCode: "",
        numCode: ""
      },
      imgCodeSrc: this.baseURL + "user/getVerifyCodeImage?t=" + +new Date(),
      imgCodeUrl: this.baseURL + "user/getVerifyCodeImage",
      validCode: {
        timeMax: 60,
        html: "获取验证码",
        load: "{time}秒后重试",
        _html: "获取验证码",
        _load: false,
        _time: 60,
        _inter: null,
        disabled: false
      }
    };
  },
  components: {},
  watch: {
    isCall () {
      this.resetForm();
    }
  },
  created () {
    if (this.params) {
      this.scopedForm.oldPhone = this.params.phone;
    }
  },
  methods: {

    submit (callback) {
      // 提交
      this.$refs.scopedForm.validate(valid => {
        if (valid) {
          var params = {
            loginPhone: this.scopedForm.newPhone,
            // oldPhone: this.scopedForm.oldPhone,
            // newPhone: this.scopedForm.newPhone,
            verificationCode: this.scopedForm.numCode,
            // verifyCodeKey: this.scopedForm.numCode
          };
          this.catReq1Service("/api/v1/user/signIn_telephone", params)
            .then(response => {


              if (!response.success) {
                return;
              }
              callback && callback(this.scopedForm.newPhone);
            })

        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    sendSMS () {

      let reg = /^1\d{10}$/;
      //console.log(1111)
      if (!reg.test(this.scopedForm.newPhone)) {
        // console.log(2222)
        return
      }
      var params = {
        // oldPhone: this.scopedForm.oldPhone,
        loginPhone: this.scopedForm.newPhone,

      };
      this.catReq1Service("/api/v1/sms/send_verifyCode", params)// 获取验证码
        .then(response => {
          let that = this
          if (!response.success) {
            return;
          }
          // 开启登录计时
          this.startCountdown();
          if (response.success) {

          }
        })
        .catch(error => {
          // this.validCode._load = false;
          //this.endCountdown();
          // this.$message({
          //   message: "网络出错!",
          //   type: "error"
          // });
        });
    },

    startCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = true;
      this.startCountdownCore();
      this._inter = setInterval(() => {
        this.startCountdownCore();
        if (this.validCode._time <= 0) {
          this.endCountdown();
        }
      }, 1000);
    },
    startCountdownCore () {
      this.validCode._time--;
      this.validCode._html = this.validCode.load.replace(
        /\{time\}/g,
        ("0000" + this.validCode._time).substr(-2, 2)
      );
    },
    endCountdown () {
      clearInterval(this._inter);
      this.validCode.disabled = false;
      this.validCode._html = this.validCode.html; // 获取验证码
      this.validCode._time = this.validCode.timeMax; // 60
      this.validCode._load = false;
      this.validCode._inter = null;
    },
    getImgCode () {
      this.imgCodeSrc = this.imgCodeUrl + "?t=" + +new Date();
    },

  }
};
function isPhone (rule, value, next) {
  var reg = /^1\d{10}$/;
  if (value === "" || value == void 0) {
    next("*请输入手机号");
  } else if (!reg.test(value)) {
    next("*请输入正确的手机号");
  } else {
    next();
  }
}
</script>

<style lang="less" scoped>
.form-box {
  margin: 0 auto;
  width: 378px;
  text-align: left;
  padding: 0 50px;
}
.imgCode {
  width: 166px;
}
.numCode {
  width: 156px;
  &.load {
    width: 140px;
  }
}
.imgCodeBtn {
  width: 84px;
  height: 36px;
  float: right;
  vertical-align: middle;
}
.numCodeBtn {
  font-size: 12px;
  padding: 12px 15px;
  color: rgba(69, 69, 69, 1);
  border: 1px solid rgba(69, 69, 69, 1);
  float: right;
}
</style>
<style>
.el-select .el-input {
  width: 100%;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>